class Alert {
  static alert(title, message, buttons) {
    const text = [title, message].filter(Boolean).join('\n');

    if (!buttons || buttons.length === 0) {
      if (typeof window !== 'undefined') {
        window.alert(text);
      }
      return;
    }

    if (buttons.length === 1) {
      if (typeof window !== 'undefined') {
        window.alert(text);
      }
      if (typeof buttons[0].onPress === 'function') {
        buttons[0].onPress();
      }
      return;
    }

    // Multiple buttons (e.g. Cancel and Exit/Confirm)
    if (typeof window !== 'undefined') {
      const confirmed = window.confirm(text);
      if (confirmed) {
        const confirmBtn = buttons.find((b) => b.style !== 'cancel') || buttons[1] || buttons[0];
        if (confirmBtn && typeof confirmBtn.onPress === 'function') {
          confirmBtn.onPress();
        }
      } else {
        const cancelBtn = buttons.find((b) => b.style === 'cancel');
        if (cancelBtn && typeof cancelBtn.onPress === 'function') {
          cancelBtn.onPress();
        }
      }
    }
  }
}

module.exports = Alert;
module.exports.default = Alert;
module.exports.Alert = Alert;
